/** The key for AWIN tracking, used around various places. e.g. the incoming URLs have this key as the query string
 * parameter key, our internal tracking for utms/attribution uses it as the key into that record.
 */
export const AWIN_TRACKING_KEY = 'awc';
export const AWIN_MERCHANT_ID = '130687';

export function getAwinCommissionGroup(
  drawTypePlanCode: string,
  drawDays: 'Tuesday' | 'Friday' | 'Both',
) {
  // ENG-1839 - AWIN say we shouldn't use commission groups. Previously, we did: return `${drawTypePlanCode}_${drawDays === 'Both' ? 'TWO_DRAWS' : 'ONE_DRAW'}`;
  return 'DEFAULT';
}
